export class HttpGetError extends Error {
  status: number;

  constructor(message = 'Unknown GET Error', status: number) {
    super(message);
    this.status = status;
    this.name = 'HttpGetError';
  }
}
